import React, { useEffect, useState } from "react";
import { AgGridReact } from "ag-grid-react";
import { Col, Row, Card, Dropdown } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { WV_APP_METRICS } from "../../../shared/constants/Constants";
import Breadcrumbs from "../../../shared/components/Breadcrumbs";
import { loadWVMetricsDataRequest } from "../redux/Actions";
import { ResponsiveContainer, Bar, BarChart, AreaChart, Area, LineChart, Line, CartesianGrid, Legend, XAxis, YAxis, Tooltip, Cell } from 'recharts';

const WVAppMetrics = () => {
  const [dateRange, setDateRange] = useState(7);
  let dispatch = useDispatch();
  let navigate = useNavigate();
  let location = useLocation();
  let {wvmetrics} = useSelector((state) => state.chatgroup);
  console.log("wvmetrics",wvmetrics);

  
  useEffect(() => {
    dispatch(loadWVMetricsDataRequest( dateRange ));
  }, [dateRange, dispatch]);

  const handleDateRangeChange = (range) => {
    setDateRange(range); 
  };  

  const getDateRangeText = () => {
    switch (dateRange) {
      case 7:
        return "Last 7 Days";
      case 30:
        return "Last 30 Days";
      case 90:
        return "Last 90 Days";
      default:
        return "Select Date Range";
    }
  };

  return (
    <>
      <div>
        <Row>
          <Col className="gx-0">
            <Breadcrumbs
              children={[
                { label: WV_APP_METRICS },
              ]}
            />
          </Col>
          <Col xs="auto" className="gx-0"></Col>
        </Row>
        <Row>
          <Col>
          <div className="mb-1">
              <select
                className="float-end form-control form-select metrics-filter-select"
                style={{
                  width: '200px',
                  marginTop: '-40px',
                  zIndex: 1000,
                  backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'%3E%3Cpath fill='%23ff7f0e' d='M0 0L2 2L4 0z'/%3E%3C/svg%3E")`,
                }}
                onChange={(e) => {
                  const selectedPath = e.target.value;
                  if (selectedPath) {
                    navigate(selectedPath);
                  }
                }}
              >
              <option value="/wvappmetrics?filter=none">WV App Metrics</option>
              <option value="/metrics?filter=none">Chat Metrics</option>
              <option value="/dashboard?filter=none">MDS Metric</option>              
              
              </select>
            </div>
          </Col>
        </Row>
        <Row>
          <Card>
            <Card.Body>
            <div className="text-end mb-3">
                <Dropdown>
                  <Dropdown.Toggle className="default-btn-color pt-1 pb-1 btn btn-primary" id="dropdown-basic">
                    {getDateRangeText()} {/* Show selected range */}
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Dropdown.Item onClick={() => handleDateRangeChange(7)}>Last 7 Days</Dropdown.Item>
                    <Dropdown.Item onClick={() => handleDateRangeChange(30)}>Last 30 Days</Dropdown.Item>
                    <Dropdown.Item onClick={() => handleDateRangeChange(90)}>Last 90 Days</Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
              <Row className="gy-1 dashboard">
                <Col xs={12} md={6} lg={3}>
                  <StatTile
                    text={"Today Active WV App Users"}
                    number={wvmetrics?.todayActiveAppUsers}
                    color="#09b8e4"
                    icon={"fas fa-users"}
                  />
                </Col>

                <Col xs={12} md={6} lg={3}>
                  <StatTile
                    text={"Today Active Vsales Web Users"}
                    number={wvmetrics?.todayActiveVsalesWebUsers}
                    color="#09b8e4"
                    icon={"fas fa-users"}
                  />
                </Col>

                {/* <Col xs={12} md={6} lg={3}>
                  <StatTile
                    text={"Today Sales Transaction"}
                    number={0}
                    color="#09b8e4"
                    icon={"fas fa-users"}
                  />
                </Col> */}

                {/* <Col xs={12} md={6} lg={3}>
                  <StatTile
                    text=""
                    number=""
                    color={"#fa9b1e"}
                    icon="fas fa-store"
                  />
                </Col>
                <Col xs={12} md={6} lg={3}>
                  <StatTile
                    text=""
                    number=""
                    color={"#1fb81f"}
                    icon="fas fa-users"
                  />
                </Col> */}
              </Row>
              <Row className={"gy-3 my-1 dashboard"}>
                <Col xs={12} lg={12}>
  <Card style={{ border: 0, borderLeft: `3px solid #5C5CAD`, boxShadow: "-2px 2px 5px #0002" }}>
    <Card.Body>
      <p className="card-title">WV App & Vsales Web Users</p>
      <div style={{ height: '360px' }}>
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={wvmetrics?.dateWiseActiveUsers || []}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="date" />
            <YAxis />
            <Tooltip />
            <Legend />
            <Line type="monotone" dataKey="appUsers" stroke="#8884d8" name="App Users" strokeWidth={2} dot={{ r: 4 }} />
           <Line type="monotone" dataKey="vsalesWebUsers" stroke="#82ca9d" name="Vsales Web Users" strokeWidth={2} dot={{ r: 4 }} /> 
           </LineChart>
        </ResponsiveContainer>
      </div>
    </Card.Body>
  </Card>
            </Col>
                
              </Row>
            </Card.Body>
          </Card>
        </Row>
      </div>
    </>
  );
};

export default WVAppMetrics;

function StatTile({ number, color, onClick, text, icon }) {
  return (
    <Card
      className="statCard clickable"
      style={{ borderLeft: `3px solid ${color}` }}
      onClick={onClick}
    >
      <Card.Body>
        <div className="d-flex align-items-center">
          <div>
            <p className="mb-0 text-secondary statTile-txt" style={{  }} >{text}</p>
            <h4 className="my-1" style={{ color: color }}>
              {number}
            </h4>
          </div>
          <div
            className="widgets-icons-2 rounded-circle text-white ms-auto"
            style={{
              background: `linear-gradient(45deg, ${color}, 80%, #f28f3420), 100%`,
            }}
          >
            <i className={icon}></i>
          </div>
        </div>
      </Card.Body>
    </Card>
  );
}
